import { render } from "./KeepWatchingCard.vue?vue&type=template&id=55211f23&scoped=true"
import script from "./KeepWatchingCard.vue?vue&type=script&lang=js"
export * from "./KeepWatchingCard.vue?vue&type=script&lang=js"

import "./KeepWatchingCard.vue?vue&type=style&index=0&id=55211f23&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55211f23"]])

export default __exports__